<template>
  <div class="product-layout">
    <action-dispatcher
      action="product/getProduct"
      :parameters="$route.params.id"
    >
      <div
        class="d-flex flex-column flex-lg-row justify-content-between align-items-center mb-4"
      >
        <new-product-dropdown :product="product" :dropdown="showDropdown" />
        <action-dispatcher
          small
          action="membersSetup/get"
          :parameters="$route.params.id"
          v-if="product && product.is_blitz_members"
        >
          <snow-button
            variant="outline"
            text="Acessar área de membros"
            right-icon="ph ph-arrow-square-out"
            @click="openMembers"
          />
        </action-dispatcher>
      </div>

      <div v-if="!$route.meta.aside">
        <router-view />
      </div>

      <router-view v-else />
    </action-dispatcher>
  </div>
</template>

<script>
import SnowButton from "@/components/snow-ui/SnowButton.vue";
import BreadcrumbsMixin from "@/mixins/breadcrumbs";
import { getToken } from "@/setup/api";
import { mapState } from "vuex";
import NewProductDropdown from "../components/product/NewProductDropdown.vue";

export default {
  mixins: [BreadcrumbsMixin],
  components: { NewProductDropdown, SnowButton },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersSetup", ["setup"]),
    membersURL() {
      return `https://${
        this.setup?.subdomain
      }.club.app2sales.com.br/token?token=${getToken()}`;
    },
    showDropdown() {
      return ["active", "inactive"].includes(this.product?.status);
    }
  },
  methods: {
    openMembers() {
      window.open(this.membersURL, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.product-layout {
  a {
    color: var(--dark);

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
